import * as React from "react";

function Arrow(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={18} height={14} fill="none" {...props}>
      <path
        d="M11.912 1.18a.552.552 0 00-.817 0 .63.63 0 000 .852l4.141 4.361H1.572c-.319 0-.572.267-.572.603 0 .335.253.61.572.61h13.664l-4.14 4.353a.641.641 0 000 .86c.228.241.596.241.816 0l5.121-5.393a.614.614 0 000-.851L11.912 1.18z"
        fill="currentColor"
        stroke="currentColor"
      />
    </svg>
  );
}

const MemoArrow = React.memo(Arrow);
export default MemoArrow;
